// cSpell:ignore Silae
import type { SilaeConditionOperator } from "@/types/silae";
import type { FormatterContext } from "./types";

const OPERATOR_FALLBACKS: Record<string, string> = {
  ">=": "supérieur ou égal à",
  "<=": "inférieur ou égal à",
  "=": "égal à",
  "!=": "différent de",
  "<>": "différent de",
  ">": "supérieur à",
  "<": "inférieur à",
};

const OPERATOR_KEYS: Record<string, string> = {
  ">=": "gte",
  "<=": "lte",
  "=": "eq",
  "!=": "neq",
  "<>": "neq",
  ">": "gt",
  "<": "lt",
};

export function formatOperator(
  operator: SilaeConditionOperator | string | undefined,
  ctx: FormatterContext,
): string {
  const op = operator ?? "=";
  const key = OPERATOR_KEYS[op];
  const fallback = OPERATOR_FALLBACKS[op] ?? OPERATOR_FALLBACKS["="];
  if (!key) return fallback;
  return ctx.t(`step5Validation.formatters.operators.${key}`, fallback);
}
